import {
  InsertInOrderedListParametersType,
  InsertVisitInOrderedListParametersType,
  Order,
} from 'src/utilities/types';
import { VISITOR_VISIT_MAX_LENGTH } from 'src/utilities/constants';

export class ListUtilities {
  /**
   * Insert element in ordered list, if element already exists in list, does nothing
   * @param list - list to insert element
   * @param element - element to insert
   * @param order - order of list
   */
  static insertInOrderedListMutably({
    list,
    element,
    order,
  }: InsertInOrderedListParametersType): void {
    if (list.includes(element)) {
      return;
    }

    const index = list.findIndex((item) =>
      order === Order.Ascending ? item >= element : item <= element,
    );

    if (index === -1) {
      list.push(element as any);
    } else {
      list.splice(index, 0, element);
    }
  }

  /**
   * Insert visit in ordered list, if visit already exists in list, does nothing
   * @param list - list to insert element
   * @param visit - visit to insert
   */
  static insertVisitInOrderedListMutably({
    list,
    visit,
  }: InsertVisitInOrderedListParametersType): void {
    // Check if the visit already exists in the list
    const currentVisit = list.find((item) =>
      typeof item === 'number'
        ? item === visit.timeStarted
        : item.timeStarted === visit.timeStarted,
    );
    if (currentVisit) {
      return;
    }

    const index = list.findIndex((item) => {
      if (typeof item === 'number') {
        return item >= visit.timeStarted;
      }
      return item.timeStarted >= visit.timeStarted;
    });

    if (index === -1) {
      list.push(visit);
    } else {
      list.splice(index, 0, visit);
    }

    if (list.length > VISITOR_VISIT_MAX_LENGTH) {
      list.splice(0, list.length - VISITOR_VISIT_MAX_LENGTH);
    }
  }
}
